import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const PaymentPage: FC = () => {
  return <Outlet />;
};
